<template>
    <span>
        <p v-if="nodeData.display_style==='hrzt'">{{ nodeData.title }}: {{ displayNodeNames.join(', ') }}</p>
        <p v-else-if="nodeData.display_style==='vert'">
            {{ nodeData.title }}:            
            <ul>
                <li v-for="name in displayNodeNames" v-bind:key="name">{{ name }}</li>
            </ul>
        </p>
    </span>
</template>

<script>
export default {
    name: 'nodeinfo',
    props: {
        nodeData: {
            type: Object,
            required: true
        },
        pageNodes: {
            type: Array,
            required: true
        },
    },
    computed: {
        displayNodes: function() {
            var comp_node = this.nodeData.node_info_of.path
            return this.pageNodes.filter(node => {
                return node.path.startsWith(comp_node) && node.path !== comp_node
            })
        },
        displayNodeNames: function() {
            var names = []
            for (var node in this.displayNodes) {
                names.push(this.displayNodes[node].name)
            }
            return names
        }
        // displayNodesB: function() {
        //     var d_nodes = []
        //     var comp_node = this.nodeData.node_info_of.path
        //     for (var node in this.pageNodes) {
        //         if (this.pageNodes[node].path.startsWith(comp_node)) {
        //             d_nodes.push(this.pageNodes[node].name)
        //         }
        //     }
        //     return d_nodes
        // },
    }
}
</script>